import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

const height = '9%';

module.exports = {
    sprayGuy1: {
        type: 'movieclip',
        scale: {
            y: '43%',
        },
        position: {
            x: '8%',
            y: height,
        },
        texture: `sprite:/img/partials/blobs-treadmill/spray-guy-${prefix}.json,spray-guy/1`,
        effectSpriteKey: 'sprayGuyEffect',
        effectPositions: [
            [{
                position: {
                    x: '40.6%',
                    y: '46.5%'
                },
                rotation: -4
            }],
            [{
                position: {
                    x: '54%',
                    y: '57.1%'
                },
                rotation: -20
            }],
            [{
                position: {
                    x: '56.8%',
                    y: '52.5%'
                },
                rotation: -15
            }],
            [{
                position: {
                    x: '47.3%',
                    y: '48.1%'
                },
                rotation: -6
            }],
            [{
                position: {
                    x: '37.9%',
                    y: '53.4%'
                },
                rotation: -14
            }],
            [{
                position: {
                    x: '46.7%',
                    y: '55%'
                },
                rotation: -11
            }],
            [{
                position: {
                    x: '43.4%',
                    y: '53.2%'
                },
                rotation: -15
            }]
        ]
    },

    sprayGuy2: {
        type: 'movieclip',
        scale: {
            y: '43%'
        },
        position: {
            x: '8%',
            y: height,
        },
        texture: `sprite:/img/partials/blobs-treadmill/spray-guy-${prefix}.json,spray-guy/2`,
        effectSpriteKey: 'sprayGuyEffect',
        effectPositions: [
            [{
                position: {
                    x: '38.6%',
                    y: '51.1%'
                },
                rotation: -40
            }],
            [{
                position: {
                    x: '43.5%',
                    y: '51.1%'
                },
                rotation: -38
            }],
            [{
                position: {
                    x: '55.8%',
                    y: '53.4%'
                },
                rotation: 0
            }],
            [{
                position: {
                    x: '44.4%',
                    y: '47.7%'
                },
                rotation: -14
            }],
            [{
                position: {
                    x: '33.3%',
                    y: '47.2%'
                },
                rotation: -49
            }],
            [{
                position: {
                    x: '38%',
                    y: '48.1%'
                },
                rotation: -38
            }],
            [{
                position: {
                    x: '47.9%',
                    y: '51.7%'
                },
                rotation: -12
            }]
        ]
    },

    sprayGuy3: {
        type: 'movieclip',
        scale: {
            y: '43%'
        },
        position: {
            x: '8%',
            y: height,
        },
        texture: `sprite:/img/partials/blobs-treadmill/spray-guy-${prefix}.json,spray-guy/3`,
        effectSpriteKey: 'sprayGuyEffect',
        effectPositions:[
            [{
                position: {
                    x: '29.4%',
                    y: '52.1%'
                },
                rotation: -20
            }],
            [{
                position: {
                    x: '60.5%',
                    y: '49.4%'
                },
                rotation: -22
            }],
            [{
                position: {
                    x: '20.6%',
                    y: '55.3%'
                },
                rotation: -16
            }],
            [{
                position: {
                    x: '40.1%',
                    y: '46%'
                },
                rotation: -3
            }],
            [{
                position: {
                    x: '63.7%',
                    y: '46.4%'
                },
                rotation: -16
            }],
            [{
                position: {
                    x: '73.2%',
                    y: '57.2%'
                },
                rotation: -20
            }],
            [{
                position: {
                    x: '20.3%',
                    y: '46.2%'
                },
                rotation: 5
            }],
            [{
                position: {
                    x: '68.9%',
                    y: '49.8%'
                },
                rotation: -22
            }],
            [{
                position: {
                    x: '65.1%',
                    y: '44.7%'
                },
                rotation: -25
            }]
        ]
    },

    sprayGuyEffect: {
        scale: {
            x: '10%'
        },
        anchor: {
            x: 0.5,
            y: 0
        },
        texture: '/img/partials/blobs-treadmill/spray-effect.png'
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/sprayGuy.js